import { makeStyles } from '@barracuda-internal/bds-core'

const styles = makeStyles(theme => ({
  inlineButton: {
    marginLeft: theme.spacing(2)
  }
}))

export default styles
